import { Iterable as ImmutableIterable } from 'immutable';
export const checkIsKeyedIterable = options => ImmutableIterable.isIterable(options) && ImmutableIterable.isKeyed(options);